import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE} from 'util/constants';

/* IMPORTANT: Services is not being using right now
   each vendor has his own endpoint, check endpoints.services */

const
    name = 'services',
    exports = storeModuleFactory({
        name,
        timeout:  TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        endpoint: endpoints.services.allServices.endpoint
    });

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/services.js